import { useEffect, useState } from 'react';
import './styles.scss';
import { useDispatch } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { updateHeader } from '../../slices/header-slice';
import { getMailChimpCampaign } from '../../api';

const Newsletter = () => {
    const dispatch = useDispatch();
    const { campaignId } = useParams();
    const [post, setPost] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        dispatch(updateHeader('light'));
    }, [dispatch]);

    useEffect(() => {
        const fetchCampaign = async () => {
            if (campaignId) {
                try {
                    setIsLoading(true);
                    setError(null);
                    const response = await getMailChimpCampaign(campaignId);
                    setPost(response.data);
                } catch (err) {
                    console.error('Error fetching campaign:', err);
                    setError('Failed to load newsletter content');
                } finally {
                    setIsLoading(false);
                }
            }
        };

        fetchCampaign();
    }, [campaignId]);

    // Alternative approach: Create a blob URL for iframe (commented out)
    const createIframeContent = (htmlContent) => {
        const blob = new Blob([htmlContent], { type: 'text/html' });
        return URL.createObjectURL(blob);
    };

    if (isLoading) {
        return (
            <div className="newsletter-post-page">
                <div className='content'>
                    <div className='loading-state'>
                        <div className='loader'></div>              
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="newsletter-post-page">
                <div className='content'>
                    <div className='error-state'>
                        <p>{error}</p>
                        <Link to="/media" className="cta gold-fill">Back to Media</Link>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="newsletter-post-page">        
            {post && (
                <>
                    <div className='content'>
                        {/* Option 1: Direct HTML rendering with CSS isolation */}
                        {/* <div className='html-text' dangerouslySetInnerHTML={{ __html: post }} /> */}
                        
                        {/* Option 2: Iframe approach for complete isolation (uncomment if needed) */}
                        <iframe
                            src={createIframeContent(post)}
                            className="campaign-iframe"
                            title="Newsletter Content"
                            sandbox="allow-same-origin allow-scripts"
                        />
                        
                        <Link to="/media" className="cta gold-fill">Back to Media</Link>
                    </div>
                </>
            )}
        </div>
    );
};

export default Newsletter;
